<h1>{{ "refueling" | translate }}</h1>

<div class="frame-parent" *ngIf="!showResume">
  <div class="frame-group">
    <div class="title-parent">
      <div class="tag">
        <img class="custom-icons" alt="" src="assets/icons/clock-icon.svg" />
        <div class="text">15 min</div>
        <img src="assets/icons/cash-icon.svg" class="to-consult-price-icon" />
        <span>{{ totalOrderAmount }}€</span>
      </div>
    </div>
    <div class="llenamos-el-depsito">
      {{ "refueling-description" | translate }}
    </div>
  </div>
  <div class="title-group">
    <div class="title">
      <div class="title1">{{ "how-does-it-work" | translate }}</div>
    </div>
    <div class="tag-parent">
      <div class="tag1">
        <img
          class="custom-icons1"
          alt=""
          src="assets/icons/calender-icon.svg"
        />
        <div class="text1">
          {{ "how-does-it-work-text-1" | translate }}
        </div>
      </div>
      <div class="tag2">
        <img class="custom-icons1" alt="" src="assets/icons/driver-icon.svg" />
        <div class="text1">{{ "how-does-it-work-text-2" | translate }}</div>
      </div>
      <div class="tag1">
        <img class="custom-icons1" alt="" src="assets/icons/center-icon.svg" />
        <div class="text1">
          {{ "how-does-it-work-text-3" | translate }}
        </div>
      </div>
      <div class="tag1">
        <img
          class="custom-icons1"
          alt=""
          src="assets/icons/location-icon.svg"
        />
        <div class="text1">
          {{ "how-does-it-work-text-4" | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="seguro">
    <div class="text5">
      <img class="logo-icon" alt="" src="assets/icons/mapfre-logo.svg" />
      <div class="card-title-parent">
        <div class="card-title">
          <div class="card-title1">{{ "breathe-easy" | translate }}</div>
        </div>
        <div class="card-title">
          <div class="descripcin">
            {{ "breathe-easy-text" | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="requisitos">
    <div class="title">
      <div class="title1">{{ "requirements-for-solicitude" | translate }}</div>
    </div>
    <div class="tag-parent">
      <div class="tag2">
        <img
          class="custom-icons1"
          alt=""
          src="assets/icons/document-ok-icon.svg"
        />
        <div class="text1">
          {{ "requirements-for-solicitude-text-1" | translate }}
        </div>
      </div>
      <div class="tag2">
        <img
          class="custom-icons1"
          alt=""
          src="assets/icons/document-text-icon.svg"
        />
        <div class="text1">
          {{ "requirements-for-solicitude-text-2" | translate }}
        </div>
      </div>
      <div class="tag2">
        <img
          class="custom-icons1"
          alt=""
          src="assets/icons/document-insurance-icon.svg"
        />
        <div class="text1">
          {{ "requirements-for-solicitude-text-3" | translate }}
        </div>
      </div>
      <div class="tag2">
        <img class="custom-icons1" alt="" src="assets/icons/refuel-icon.svg" />
        <div class="text1">
          {{ "requirements-for-solicitude-text-4" | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="legal-text">
    <div class="lorem-ipsum">
      <span [innerHTML]="'legal-text' | translate"></span>
    </div>
  </div>
  <div class="title-container">
    <div class="title6">
      <div class="title7">{{ "service-price" | translate }}</div>
    </div>
    <div class="instance-wrapper">
      <div class="price-wrapper">
        <div class="price">{{ totalOrderAmount }}€</div>
      </div>
    </div>
  </div>
  <div class="button-container">
    <ng-content select="[left-button]"></ng-content>
    <button class="continue-button" (click)="showForm()">
      {{ "continue" | translate }}
    </button>
  </div>
</div>

<div class="repostaje-container" *ngIf="showResume">
  <div class="form-group">
    <div class="label-container">
      <label>{{ "pick-the-fuel" | translate }}</label>
      <span class="required-tag">{{ "mandatory" | translate }}</span>
    </div>

    <div class="option-list">
      <div
        class="option-item"
        [class.selected]="selectedFuel === 'gasolina95'"
        (click)="selectFuel('gasolina95')"
        *ngIf="fuelTypeFromSummaryData == 1 || fuelTypeFromSummaryData == 5"
      >
        <span>{{ "petrol-95" | translate }}</span>
        <div
          class="radio-button"
          [class.active]="selectedFuel === 'gasolina95'"
        ></div>
      </div>

      <div
        class="option-item"
        [class.selected]="selectedFuel === 'gasolina98'"
        (click)="selectFuel('gasolina98')"
        *ngIf="fuelTypeFromSummaryData == 1 || fuelTypeFromSummaryData == 5"
      >
        <span>{{ "petrol-98" | translate }}</span>
        <div
          class="radio-button"
          [class.active]="selectedFuel === 'gasolina98'"
        ></div>
      </div>

      <div
        class="option-item"
        [class.selected]="selectedFuel === 'diesel'"
        (click)="selectFuel('diesel')"
        *ngIf="fuelTypeFromSummaryData == 3 || fuelTypeFromSummaryData == 5"
      >
        <span>{{ "diesel" | translate }}</span>
        <div
          class="radio-button"
          [class.active]="selectedFuel === 'diesel'"
        ></div>
      </div>

      <div
        class="option-item"
        [class.selected]="selectedFuel === 'dieselPremium'"
        (click)="selectFuel('dieselPremium')"
        *ngIf="fuelTypeFromSummaryData == 3 || fuelTypeFromSummaryData == 5"
      >
        <span>{{ "premiun-diesel" | translate }}</span>
        <div
          class="radio-button"
          [class.active]="selectedFuel === 'dieselPremium'"
        ></div>
      </div>
    </div>
  </div>

  <div class="form-group">
    <div class="label-container">
      <label>{{ "pick-the-amount" | translate }}</label>
      <span class="required-tag">{{ "mandatory" | translate }}</span>
    </div>

    <div class="option-list">
      <div
        class="option-item"
        [class.selected]="selectedAmount === 10"
        (click)="selectAmount(10)"
      >
        <span>10€</span>
        <div class="radio-button" [class.active]="selectedAmount === 10"></div>
      </div>

      <div
        class="option-item"
        [class.selected]="selectedAmount === 20"
        (click)="selectAmount(20)"
      >
        <span>20€</span>
        <div class="radio-button" [class.active]="selectedAmount === 20"></div>
      </div>

      <div
        class="option-item"
        [class.selected]="selectedAmount === 50"
        (click)="selectAmount(50)"
      >
        <span>50€</span>
        <div class="radio-button" [class.active]="selectedAmount === 50"></div>
      </div>

      <div
        class="option-item"
        [class.selected]="selectedAmount === 60"
        (click)="selectAmount(60)"
      >
        <span>60€</span>
        <div class="radio-button" [class.active]="selectedAmount === 60"></div>
      </div>
    </div>
  </div>

  <div class="info-box">
    <img src="assets/icons/shield-exclamation.svg" alt="" />
    <p>
      {{ "legal-text-refueling" | translate }}
    </p>
  </div>
  <div class="button-container">
    <ng-content select="[left-button]"></ng-content>

    <button
      class="continue-button2"
      [disabled]="!isFormValid()"
      [class.disabled]="!isFormValid()"
      (click)="submitForm()"
    >
      {{ "continue" | translate }}
    </button>
  </div>
</div>
